export default __webpack_public_path__ + "static/media/competitors.220958bf.png";